// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_sv-0";
export var checkoutRateBadgeLink = "_sv-1";